import { render, staticRenderFns } from "./AuthenticatedHeader.vue?vue&type=template&id=5672bdf4&scoped=true&"
import script from "./AuthenticatedHeader.vue?vue&type=script&lang=js&"
export * from "./AuthenticatedHeader.vue?vue&type=script&lang=js&"
import style0 from "./AuthenticatedHeader.vue?vue&type=style&index=0&id=5672bdf4&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5672bdf4",
  null
  
)

export default component.exports